import { __rest } from "tslib";
import React from 'react';
import { BodyText } from "@hm-group/fabric-components/components/Typography";
import { HeadingXSmall } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./ProductTitle.css";
var styles = { "productTitle": "a04ae4", "northstar-small": "c89a46", "northstar-large": "df4417" };
import ProductLink from '../ProductLink';
const ProductTitle = (_a) => {
    var { title, variant = 'hm', titleTag = 'h3' } = _a, props = __rest(_a, ["title", "variant", "titleTag"]);
    if (!title) {
        return null;
    }
    const Component = variant === 'hm' ? BodyText : HeadingXSmall;
    return (React.createElement(ProductLink, Object.assign({}, props),
        React.createElement(Component, { Tag: titleTag, className: cn(styles.productTitle, styles[variant]), hasEllipsis: true }, title)));
};
export default ProductTitle;
//# sourceMappingURL=ProductTitle.js.map